import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IMaterialDataService,
  Material,
  MaterialFilters,
  CreateMaterialDto,
} from '@infinitform/platform-core';
import { CLOUD_PLATFORM_CONFIG } from '../config';

@Injectable()
export class MaterialDataCloudService implements IMaterialDataService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(CLOUD_PLATFORM_CONFIG);

  private get baseUrl(): string {
    return `${this.config.apiBaseUrl}/materials`;
  }

  find(filters?: MaterialFilters): Observable<Material[]> {
    let params = new HttpParams();

    if (filters?.name) {
      params = params.set('search', filters.name);
    }
    if (filters?.category) {
      params = params.set('category', filters.category);
    }
    if (filters?.type) {
      params = params.set('type', filters.type);
    }
    if (filters?.manufacturingMethod) {
      params = params.set('manufacturingMethod', filters.manufacturingMethod);
    }

    return this.http.get<Material[]>(this.baseUrl, { params });
  }

  findOne(id: string): Observable<Material> {
    return this.http.get<Material>(`${this.baseUrl}/${id}`);
  }

  create(data: CreateMaterialDto): Observable<Material> {
    return this.http.post<Material>(this.baseUrl, data);
  }

  update(id: string, data: Partial<Material>): Observable<Material> {
    return this.http.patch<Material>(`${this.baseUrl}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  duplicate(id: string): Observable<Material> {
    return this.http.post<Material>(`${this.baseUrl}/${id}/duplicate`, {});
  }
}
